import React, { useEffect } from 'react'
import { useRouter } from 'next/router'

import { useIsLoggedIn } from '../hooks/authHooks'
import { useIsValidSession } from '../hooks/newReportHooks'

import AboutYou from '../containers/AboutYou'
import Page from '../containers/Page'

import NoFormSessionError from '../components/NoFormSessionError'
import { ContentBlock } from 'components/Blocks'

const AboutYouPage = ({ websiteConfig }) => {
  const isLoggedIn = useIsLoggedIn()
  const router = useRouter()
  const reportId = router && router.query.reportId
  const isValidSession = reportId && useIsValidSession({ reportId })

  useEffect(() => {
    if (isLoggedIn && isValidSession) {
      router.replace({
        pathname: '/new-report',
        query: {
          reportId
        }
      })
    }
  }, [isLoggedIn, isValidSession])

  return (
    <Page>
      {!isValidSession && (
        <ContentBlock>
          <NoFormSessionError />
        </ContentBlock>
      )}
      {isValidSession && !isLoggedIn && <AboutYou websiteConfig={websiteConfig} />}
    </Page>
  )
}

export default AboutYouPage
